export const EventVisibility = {
	PUBLIC:  'public',
	HIDDEN:  'hidden',
	PRIVATE: 'private',
	CUSTOM:  'custom',
};
